import React from 'react'
import { Link, Flex, Icon, Text, Center, Tooltip } from '@chakra-ui/react'
import { NavLink as RouterLink } from 'react-router-dom'

function SideNavItem({ index = 0, type = 'main', icon, children, isNormal, show, ...rest }) {
  if (typeof show === 'boolean' && !show) return null
  const isLocalLink = !!rest.to
  const delay = index * 30 + 150 + 'ms'
  const iconSize = type === 'main' ? 32 : 24
  const linkStyle = isLocalLink
    ? isActive => ({
        borderColor: isActive ? 'var(--main)' : 'transparent'
      })
    : {
        borderColor: 'transparent'
      }
  return (
    <Link
      as={isLocalLink ? RouterLink : null}
      target={!isLocalLink ? '_blank' : null}
      rel={!isLocalLink ? 'noreferrer' : null}
      style={linkStyle}
      textDecoration="none"
      borderLeftWidth="4px"
      w="full"
      {...rest}
    >
      <Flex align="center" role="group" cursor="pointer">
        <Tooltip
          label={children}
          placement="right"
          bg="brand.front"
          color="brand.nav"
          isDisabled={isNormal}
          fontSize="md"
          px="4"
          py="2"
        >
          <Center
            width="58px"
            h={`${iconSize + 8}px`}
            px="3"
            py="1"
            mr="1"
            pos="relative"
            bg="brand.front"
            zIndex="1"
          >
            {icon && <Icon w="32px" fontSize={`${iconSize}px`} as={icon} strokeWidth="1" />}
          </Center>
        </Tooltip>
        <Text
          whiteSpace="nowrap"
          opacity={isNormal ? 1 : 0}
          transform={isNormal ? '' : 'translateX(-50%)'}
          visibility={isNormal ? 'visible' : 'hidden'}
          transition={`transform .175s ease ${delay}, opacity .5s ease ${delay}`}
        >
          {children}
        </Text>
      </Flex>
    </Link>
  )
}

export default SideNavItem
